<template>
  <div
    class="TicketMedio"
    v-loading="loadingPage"
    style="padding: 10px; background: #fff; border-radius: 4px"
  >
    <div class="space-between">
      <h4 style="text-align: left; margin-bottom: 1rem">Ticket Médio</h4>
      <div :class="{ red: list.percent < 0 }">
        <i v-if="list.percent >= 0" class="el-icon-top-right"></i>
        <i v-else class="el-icon-bottom-right"></i>
        <strong> {{ list.percent }}% </strong>
      </div>
    </div>
    <div class="boxDetalhesCard">
      <div class="box atual bg-gray" style="color: #000">
        <div class="cont">
          <span style="color: #000">Mês atual</span>
          <strong style="color: #000">{{ list.amountCurrentMonthly.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</strong>
        </div>
      </div>
      <div class="box passado passado ml-5 " style="border: 1px solid #ececf5;border-radius: 8px;margin-left: 10px;">
        <div class="cont">
          <span>Mês anterior</span>
          <strong>
            {{ list.amountBeforeMonthly.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
          </strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isNull } from "lodash";
import { getProgressionEC, getTicketMedio } from "@/app/domains/Core/services";
import { makeErrorFilds } from "@/app/plugins/utils";

export default {
  name: "TicketMedio",
  props: {
    querySearch: {
      type: [],
      default: "",
    },
  },
  data() {
    return {
      value: "1,56",
      loadingPage: false,
      list: {
        amountBeforeMonthly: "",
        amountCurrentMonthly: "",
        percent: "",
      },
    };
  },
  watch: {
    querySearch: async function (query) {
      await this.init(query, true);
    },
  },
  methods: {
    formatReal(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        currency: "BRL",
        minimumFractionDigits: 2,
      }).format(value);
    },
    stringToFloat(number) {
      let res = parseFloat(number.replace(",", ""));
      return res;
    },
    async init(query = "") {
      this.loadingPage = true;
      try {
        // let queryP = "?init_date=" + query[0] + "&finish_date=" + query[1];
        let queryP = "";
        let response = await getTicketMedio(queryP);
        this.list = response.data;
      } catch (e) {
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: "error",
        });
      } finally {
        this.loadingPage = false;
      }
    },
  },
  async beforeMount() {
    await this.init(this.querySearch);
  },
};
</script>

<style scoped></style>
